import script from "./APIClasses.vue?vue&type=script&lang=ts"
export * from "./APIClasses.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__